<template>
  <div class="monitoring-area-container">
    <div class="left">
      <ul class="tree-ul" style="position:relative;left:-6px;">
        <li>
          <div class="div">
            <img class="pull-left"
              :src="!rootShow?require('../../common/images/cata/a.png'):require('../../common/images/cata/c.png')"
              @click="rootShow=!rootShow;" />
            <span class="pull-left line" style="left:-1px"></span>
            <i class="pull-left icon iconfont icon-wenjianjia1"></i>
            <b :style="{color:index1===undefined&&index2===undefined?'#409EFF':'',fontWeight:index1===undefined&&index2===undefined?'bold':''}"
              class="pull-left t-hidden c-pointer">所有甲板</b>
            <span class="zsf-icon ml-3"
              :class="selectRoot?'zsf-icon-xuanze-fangkuang':'zsf-icon-xuanzeweixuanze'"
              @click="toggleSelect(0,-1,-1)"></span>
          </div>
          <ul class="tree-ul" style="position:relative;left:34px" v-if="rootShow">
            <li class="item1" v-for="(item1,inde1) in leftList" :key="inde1">
              <div class="div">
                <img class="pull-left" v-if="item1['son']"
                  :src="!item1['show']?require('../../common/images/cata/a.png'):require('../../common/images/cata/c.png')"
                  @click="toggle(inde1)" />
                <span class="pull-left line" :style="{width:item1['son']?'10px':'21px'}"></span>
                <i class="pull-left icon iconfont"
                  :class="item1.show&&item1['son']?'icon-ic_folder':'icon-wenjianjia1'"></i>
                <b class="pull-left t-hidden c-pointer"
                  :style="{color:index1===inde1&&index2===undefined?'#409EFF':'',fontWeight:index1===inde1&&index2===undefined?'bold':''}">{{item1.name}}</b>
                <span class="zsf-icon ml-3"
                  :class="item1.select?'zsf-icon-xuanze-fangkuang':'zsf-icon-xuanzeweixuanze'"
                  @click="toggleSelect(0,inde1,-1)"></span>
              </div>
              <div class="clearfix"></div>
              <ul class="ul2" v-if="item1.show">
                <li class=" item2" v-for="(item2,inde2) in item1.son" :key="inde2">
                  <div class="div">
                    <img class="pull-left" v-if="item2['son']"
                      :src="!item2['show']?require('../../common/images/cata/a.png'):require('../../common/images/cata/c.png')"
                      @click="toggle(inde1,inde2)" />
                    <span class="pull-left line" :style="{width:item2['son']?'10px':'21px'}"></span>
                    <i class="pull-left icon iconfont"
                      :class="item2.show&&item2['son']?'icon-ic_folder':'icon-wenjianjia1'"></i>
                    <b class="pull-left t-hidden c-pointer"
                      :style="{color:index1===inde1&&index2===inde2?'#409EFF':'',fontWeight:index1===inde1&&index2===inde2?'bold':''}">{{item2.name}}</b>
                    <span class="zsf-icon ml-3"
                      :class="item2.select?'zsf-icon-xuanze-fangkuang':'zsf-icon-xuanzeweixuanze'"
                      @click="toggleSelect(0,inde1,inde2)"></span>
                  </div>
                  <div class="clearfix"></div>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="right">
      <div class="table-prefix-box">
        <div class="btn-box">
          <el-button-group>
            <el-button @click="getData" size="mini" type="primary" icon="el-icon-search">查询
            </el-button>
            <el-button @click="reset" size="mini" type="primary" icon="el-icon-refresh">重置
            </el-button>
            <el-button @click="download" size="mini" type="primary" icon="el-icon-download">导出
            </el-button>
          </el-button-group>
        </div>
        <div class="search-box mt-15"></div>
      </div>

      <div class="table mt-15">
        <el-table v-loading="tableLoading" border ref="table" :data="list" highlight-current-row
          @current-change="handleCurrentChange" style="width:100%">
          <el-table-column label="工号" property="id"></el-table-column>
          <el-table-column label="姓名"></el-table-column>
          <el-table-column label="识别卡"></el-table-column>
          <el-table-column label="部门"></el-table-column>
          <el-table-column label="工种"></el-table-column>
          <el-table-column label="发卡时间"></el-table-column>
          <el-table-column label="当前分站"></el-table-column>
          <el-table-column label="到达分站时间"></el-table-column>
          <el-table-column label="当前区域"></el-table-column>
          <el-table-column label="更新时间"></el-table-column>
          <el-table-column label="查看"></el-table-column>
        </el-table>
      </div>

      <div class="pagination pt-10 t-center">
        <el-pagination background layout="total,sizes,prev,pager,next,jumper"
          :page-size="pagination.size" :page-sizes="[10,20,30,50]"
          :current-page.sync="pagination.page" :total="pagination.total" @size-change="changeSize"
          @current-change="changeCurrent"></el-pagination>
      </div>
    </div>

    <el-dialog :title="currentRow?'编辑':'新建'" width="400px" :visible.sync="addDialogShow">
      <div class="add-box">
        <div class="o-hidden">
          <span class="span">名称</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
        <div class="o-hidden">
          <span class="span">名称</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="addDialogShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import { tool } from "../../common/js/tool.js";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      rootShow: true,
      selectRoot: false,
      index1: undefined,
      index2: undefined,
      leftList: [],
      fullscreenLoading: false,
      obj: {
        txt: "",
        txt11: "",
        select: "",
        select11: "",
        date: "",
        datas: "",
        dateTime: "",
        number: ""
      },
      list: [],
      currentRow: null,
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      tableLoading: false,
      addobj: { name: "" },
      addDialogShow: false
    };
  },

  computed: {},

  created() {
    this.getLeftData();
    this.getData();
  },

  methods: {
    getLeftData() {
      this.leftList = [
        {
          name: "甲板1",
          id: 1,
          son: [
            { name: "基站1", id: 2 },
            { name: "基站2", id: 3 }
          ]
        },
        {
          name: "甲板2",
          id: 5,
          son: [
            { name: "基站3", id: 6 },
            { name: "基站4", id: 7 }
          ]
        },
        {
          name: "甲板3",
          id: 11,
          son: [
            { name: "基站3", id: 12 },
            { name: "基站4", id: 13 }
          ]
        },
        {
          name: "甲板4",
          id: 22,
          son: [
            { name: "基站3", id: 23 },
            { name: "基站4", id: 24 }
          ]
        },
        {
          name: "甲板5",
          id: 22,
          son: [
            { name: "基站3", id: 23 },
            { name: "基站4", id: 24 }
          ]
        },
        {
          name: "甲板6",
          id: 22,
          son: [
            { name: "基站3", id: 23 },
            { name: "基站4", id: 24 }
          ]
        }
      ];
    },
    toggleSelect(index, index1, index2) {
      let tmp = [...this.leftList];
      if (index2 > -1) {
        tmp[index1].son[index2].select = !tmp[index1].son[index2].select;
      } else if (index1 > -1) {
        tmp[index1].select = !tmp[index1].select;
        for (let i = 0; i < tmp[index1].son.length; i++) {
          tmp[index1].son[i].select = tmp[index1].select;
        }
      } else {
        this.selectRoot = !this.selectRoot;
        for (let i = 0; i < tmp.length; i++) {
          tmp[i].select = this.selectRoot;
          for (let j = 0; j < tmp[i].son.length; j++) {
            tmp[i].son[j].select = this.selectRoot;
          }
        }
      }
      this.leftList = tmp;
    },
    selectOrg(parentName, id, index1, index2) {
      this.index1 = index1;
      this.index2 = index2;
      this.obj.parentCategoryId = id;
      this.addobj.parentCategoryId = id;
      this.parentName = parentName;
      this.getData();
      if (this.selectRoot) {
        this.rootShow = !this.rootShow;
        return;
      }
      this.toggle(index1, index2);
    },
    toggle(index1, index2) {
      if (typeof index2 !== "undefined") {
        if (this.leftList[index1]["son"][index2]["show"]) {
          let tmp = [...this.leftList];
          tmp[index1]["son"][index2]["show"] = false;
          this.leftList = tmp;
        } else {
          let tmp = [...this.leftList];
          tmp[index1]["son"][index2]["show"] = true;
          this.leftList = tmp;
        }
      } else {
        if (this.leftList[index1]["show"]) {
          let tmp = [...this.leftList];
          tmp[index1]["show"] = false;
          this.leftList = tmp;
        } else {
          let tmp = [...this.leftList];
          tmp[index1]["show"] = true;
          this.leftList = tmp;
        }
      }
    },
    clickAdd() {
      this.addDialogShow = true;
      this.currentRow = null;
    },
    clickEdit() {
      if (!this.currentRow) {
        tool.message("请在表格中选择数据", "error");
        return;
      }
      this.addDialogShow = true;
    },
    download() {
      let loadingInstance = Loading.service({
        fullscreen: true,
        text: "数据生成中"
      });
      setTimeout(() => {
        loadingInstance.close();
      }, 1000);
    },
    del() {
      if (!this.currentRow) {
        tool.message("请在表格中选择数据", "error");
      } else {
        this.$confirm("确定要删除吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$message({
            type: "success",
            duration: 1000,
            message: "操作成功!",
            onClose: () => {
              this.getData();
            }
          });
        });
      }
    },
    submit() {
      console.log(this.addobj);
      this.addDialogShow = false;
    },
    getData(flag) {
      let obj = Object.assign({}, this.obj);
      obj.page = flag ? this.pagination.page : 1;
      this.pagination.page = flag ? this.pagination.page : 1;
      console.log(this.obj, this.pagination, obj);
      this.tableLoading = true;
      setTimeout(() => {
        this.tableLoading = false;
        this.pagination.total = 222;
        this.list = [
          { id: 1 },
          { id: 2 },
          { id: 3 },
          { id: 4 },
          { id: 5 },
          { id: 6 },
          { id: 7 },
          { id: 8 },
          { id: 9 },
          { id: 10 }
        ];
      }, 10);
    },
    reset() {
      this.obj.page = 1;
      this.pagination.page = 1;
      this.getData();
    },
    changeCurrent(val) {
      this.pagination.page = val;
      this.obj.page = val;
      this.getData(true);
    },

    changeSize(e) {
      this.pagination.size = e;
      this.obj.pageSize = e;
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentRow = val;
      //console.log(val.id);
    }
  },

  components: {}
};
</script>

<style lang="less" rel="stylesheet/less">
.monitoring-area-container {
  width: 100%;
  height: auto;
  display: flex;
  padding: 15px 15px 15px 21px;
  .left {
    width: 200px;
  }
  .right {
    flex: 1;
    width: 0;
  }
  .tree-ul {
    .icon-wenjianjia1,
    .icon-ic_folder {
      font-size: 16px;
      margin-right: 3px;
      margin-left: 3px;
      color: #333;
      &.icon-wenjianjia1 {
        color: #555;
        font-size: 14px;
      }
    }
    li {
      line-height: 30px;
      position: relative;
      background: url("../../common/images/cata/point-y.png") repeat-y;
      .checkbox {
        display: inline-block;
        width: 15px;
        text-align: center;
        height: 15px;
        line-height: 13px;
        border: 1px solid #bbb;
        cursor: pointer;
        position: relative;
        top: 1px;
        i {
          opacity: 0;
        }
        &.active {
          border: 1px solid green;
          i {
            color: green;
            opacity: 1;
          }
        }
      }
      .div {
        height: 30px;
        line-height: 30px;
        position: relative;
        background: url("../../common/images/cata/point-y.png") repeat-y;
      }
      img {
        width: 11px;
        display: block;
        margin-top: 9px;
        position: relative;
        z-index: 1;
        left: -5px;
      }
      .line {
        width: 10px;
        height: 2px;
        background: url("../../common/images/cata/point-x.png") repeat-x;
        margin-top: 14px;
        position: relative;
        left: 0;
      }

      .item2,
      .item3 {
        padding-left: 31px;
      }

      .icon-jia,
      .icon-jian {
        display: inline-block;
        width: 12px;
        height: 12px;
        background: white;
        position: relative;
        z-index: 1;
      }
    }
  }
}
</style>
